const NavbarItems = [
  {
    id: 1,
    title: "News",
    url: "/news",
    cname: "nav-links",
  },
  {
    id: 2,
    title: "Job Opportunity",
    url: "/job",
    cname: "nav-links",
  },
  {
    id: 3,
    title: "Contact Us",
    url: "/contacts",
    cname: "nav-links",
  },
  {
    id: 4,
    title: "Publications",
    url: "/publications",
    cname: "nav-links",
  },
  {
    id: 5,
    title: "Projects",
    url: "/projects",
    cname: "nav-links",
  },
];

export default NavbarItems;
